//----- Component --------------------------------------------------------/
// Developer     : Guillermo Sedran
// Creation Date : 13/11/2023
// Version       : 1
// Description   : Tabla principal para los hallazgos de auditoria, contiene a los demas componentes
//
//------Changes --------------------------------------------------------------------- -------------//
// Change Date   : 22/03/2024
// Change by     : Guillermo Sedran
// Change description: Condición para obtener datos al ser responsable con sector NULL
//
// Change Date   :
// Change by     :
// Change description:
//
//========================================================================/

import Navbar from "../Navbar";
import React, { useEffect, useState, useMemo } from "react";
import { UrlApi } from "../../services/apirest";
import MaterialReactTable from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es"; //Tabla en español
import {
  Button,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Box,
  Typography,
  Stack,
  Grid,
  Tooltip,
  TextField,
  Autocomplete,
  Chip,
} from "@mui/material";
import { createTheme, ThemeProvider, useTheme } from "@mui/material";

// LOG EVENTOS
import { logEventos } from "../../services/services";

// ENVIAR MAILS
import { enviarmails } from "../../services/services";

// CHECKBOX
import Checkbox from "@mui/material/Checkbox";
// import FormControlLabel from "@mui/material/FormControlLabel";

// COMPONENTES
import Auditorias_acciones from "./Auditorias_acciones";
import Auditorias_agregar_hallazgo from "./Auditorias_agregar_hallazgo";

// ICONOS
import AddBoxTwoToneIcon from "@mui/icons-material/AddBoxTwoTone";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CallMissedOutgoingIcon from "@mui/icons-material/CallMissedOutgoing";
import CircularProgress from "@mui/material/CircularProgress";
import AltRouteIcon from "@mui/icons-material/AltRoute";
import AssignmentIcon from "@mui/icons-material/Assignment";

// Notification
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

//ADJUNTAR ARCHIVOS
import { v4 as uuidv4 } from "uuid";
import FileUploadHallazgo from "./FileUploadHallazgo";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function Auditorias() {
  const [auditorias, setAuditorias] = useState({});
  const [datosAuditorias, setDatosAuditorias] = useState({});
  const [countTotal, setCountTotal] = useState(0);
  const [countRegistrado, setCountRegistrado] = useState(0);
  const [countEnProceso, setCountEnProceso] = useState(0);
  const [countFinalizado, setCountFinalizado] = useState(0);
  const [countAprobado, setCountAprobado] = useState(0);
  const [IconoDeCarga, setIconoDeCarga] = useState(false);
  const [deshabilitarBotonRechazar, setDeshabilitarBotonRechazar] =
    useState(false);
  const [deshabilitarBotonAceptar, setDeshabilitarBotonAceptar] =
    useState(false);

  // ADJUNTOS
  const [uuid_hallazgo, setUuid_hallazgo] = useState(uuidv4()); //ADJUNTAR ARCHIVOS
  const [openCloseAdj, setOpenCloseAdj] = useState(false); //ADJUNTAR COMPROBANTE
  const [newUuid, setNewUuid] = useState(""); //ADJUNTAR COMPROBANTE

  const handleOpenCloseAdj = (value) => {
    setOpenCloseAdj(value);
  };

  const [tabla, setTabla] = useState(true);
  const [disBtn, setDisBtn] = useState(false);

  const [sectores, setSectores] = useState();

  // RECARGAR
  const [recargarAcciones, setRecargarAcciones] = useState(false);

  // AUTOCOMPLETE
  const [sectorSeleccionado, setSectorSeleccionado] = useState(null);

  // DIALOG
  const [openDialogDelegar, setOpenDialogDelegar] = React.useState(false);

  // Comprobar si se ha seleccionado un sector para habilitar o deshabilitar el botón "Delegar"

  //*************************************************************************************************************************************/

  // OBTENER FECHA ACTUAL
  var curr = new Date();
  curr.setDate(curr.getDate());
  var date = curr.toISOString().substring(0, 10);

  //*************************************************************************************************************************************/

  // CASQUETE
  const [checkSwitchVerAprobados, setCheckSwitchVerAprobados] = useState(false);

  const handleOnChangeSwitchVerAprobados = (e) => {
    setCheckSwitchVerAprobados(e.target.checked);
  };

  //*************************************************************************************************************************************/

  //Notification
  const [openSnack, setOpenSnack] = React.useState(false);
  const [colormensaje, setColorMensaje] = useState("");
  const [mensaje, setMensaje] = useState("");

  //*************************************************************************************************************************************/

  //Snackbar Notificacion
  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnack(false);
    setOpenDialogConfirmar(false);
    setDeshabilitarBotonAceptar(false);
    setOpenDialogARDelegacion(false);
    setOpenDialogDelegar(false);
    obtenerAuditorias();

    setTimeout(() => {
      setRecargarAcciones(false);
    }, 500); // Retraso para recargar
  };

  //*************************************************************************************************************************************/

  const columns = useMemo(
    () => [
      { header: "ID", accessorKey: "id_hallazgo", size: 30 },
      { header: "Auditor", accessorKey: "auditor", size: 100 },
      {
        header: "F. Registro",
        accessorKey: "fecha_registro",
        size: 70,
        Cell: ({ cell }) => {
          const rawDate = cell.getValue();
          if (!rawDate) return ""; // Si no hay fecha, no mostrar nada
          const date = new Date(rawDate);
          return date.toLocaleDateString("es-AR"); // Muestra como dd/mm/aaaa
        },
      },
      { header: "Sucursal", accessorKey: "sucursal", size: 100 },
      {
        header: "Problema",
        accessorKey: "problema_sugerencia",
        size: 210,
        // Para que la celda permita salto de línea
        muiTableBodyCellProps: {
          sx: {
            whiteSpace: "normal",
            overflowWrap: "anywhere",
            wordBreak: "break-word",

            maxWidth: 420, // Ancho maximo
          },
        },
        Cell: ({ cell }) => (
          <Box
            sx={{
              whiteSpace: "normal",
              overflowWrap: "anywhere",
              wordBreak: "break-word",
            }}
          >
            {cell.getValue() ?? ""}
          </Box>
        ),
      },
      { header: "Responsable", accessorKey: "responsable", size: 100 },
      {
        header: "Sector Delegado",
        accessorKey: "nombre_sector_delegado",
        size: 120,
      },
      {
        header: "Vencimiento",
        accessorKey: "vencimiento",
        size: 85,
        Cell: ({ cell }) => {
          const rawDate = cell.getValue();
          if (!rawDate) return ""; // Si no hay fecha, no mostrar nada
          const date = new Date(rawDate);
          return date.toLocaleDateString("es-AR"); // Muestra como dd/mm/aaaa
        },
      },
      {
        header: "UUID",
        accessorKey: "uuid_hallazgo",
        size: 85,
        enableHiding: true,
      },
      { header: "Estado", accessorKey: "valor", size: 100 },
      {
        header: "Email Auditor",
        accessorKey: "email_auditor",
        size: 85,
        enableHiding: true,
      },
      {
        header: "Email Responsable",
        accessorKey: "email_responsable",
        size: 85,
        enableHiding: true,
      },
      {
        header: "ID Sector Delegado",
        accessorKey: "id_sector_delegado",
        size: 85,
        enableHiding: true,
      },
      {
        header: "Estado Delegación",
        accessorKey: "estado_delegacion",
        size: 85,
        enableHiding: true,
      },
    ],
    []
  );

  // ---------------------------------------------------------------

  const obtenerAuditorias = () => {
    const sector = localStorage.getItem("sector");
    const sucursalesAuth = localStorage.getItem("suc_auth");

    console.log("SECTOR: ", sector);
    console.log("SUC_AUTH: ", sucursalesAuth);

    if (
      sector &&
      !isNaN(parseInt(sector)) &&
      (!sucursalesAuth || sucursalesAuth.trim() === "")
    ) {
      // Si el usuario:
      // - TIENE un SECTOR
      // - pero NO tiene SUCURSALES autorizadas
      console.log("EJECUTA 1");

      fetch(UrlApi + "/auditorias/xsector/" + sector)
        .then((data) => data.json())
        .then((data) => {
          setAuditorias(data);
        });
    } else if (
      sucursalesAuth &&
      sucursalesAuth.trim() !== "" &&
      (localStorage.getItem("auditor") === "1" ||
        localStorage.getItem("controlador") === "1")
    ) {
      // Si el usuario:
      // - TIENE SUCURSALES autorizadas
      // - ES AUDITOR O CONTROLADOR
      // - pero NO tiene SECTOR
      console.log("EJECUTA 2");
      const urlxsucursales = checkSwitchVerAprobados
        ? "/auditorias/xsucursal/conaprobados/"
        : "/auditorias/xsucursal/sinaprobados/";

      fetch(UrlApi + urlxsucursales + sucursalesAuth.split(","))
        .then((data) => data.json())
        .then((data) => {
          setAuditorias(data);
          setCountTotal(data.length);
          obtenerAuditoriasRegistrado();
        });

      // console.log("SUCURSALES PERO NO SECTOR");
    } else if (
      sucursalesAuth &&
      sucursalesAuth.trim() !== "" &&
      (!sector || isNaN(parseInt(sector)))
    ) {
      console.log("EJECUTA 3");
      // Si el usuario:
      // - TIENE SUCURSALES autorizadas
      // - pero NO tiene SECTOR (RESPONSABLE)
      const urlxsucursales = "/auditorias/xsucursal/conaprobados/";

      fetch(UrlApi + urlxsucursales + sucursalesAuth.split(","))
        .then((data) => data.json())
        .then((data) => {
          setAuditorias(data);
          setCountTotal(data.length);
          obtenerAuditoriasRegistrado();
        });

      // console.log("SUCURSALES PERO NO SECTOR");
    } else if (
      sector &&
      !isNaN(parseInt(sector)) &&
      sucursalesAuth &&
      sucursalesAuth.trim() !== ""
    ) {
      // Si el usuario tiene ambos:
      // - SECTOR y SUCURSALES autorizadas
      console.log("EJECUTA 4");

      fetch(UrlApi + "/auditorias/xsector/" + sector)
        .then((dataSector) => dataSector.json())
        .then((dataSector) => {
          fetch(
            UrlApi +
              "/auditorias/xsucursal/conaprobados/" +
              sucursalesAuth.split(",")
          )
            .then((dataSucursal) => dataSucursal.json())
            .then((dataSucursal) => {
              // Combinación de los datos de ambos fetch
              const mergedData = [...dataSector, ...dataSucursal];
              setAuditorias(mergedData);
              setCountTotal(mergedData.length);
              obtenerAuditoriasRegistrado();
            });
        });
    } else {
      console.log("EJECUTA 5");
      console.log("No se cumplió ninguna condición");
    }
  };

  // ***************************************
  // CONTADORES DE CANTIDAD
  // SOLO SE MUESTRAN CUANDO ES "AUDITOR"
  // ***************************************
  const obtenerAuditoriasRegistrado = () => {
    fetch(
      UrlApi +
        "/auditorias/registrado/xsucursal/" +
        localStorage.getItem("suc_auth").split(",")
    )
      .then((data) => data.json())
      .then((data) => {
        setCountRegistrado(data.length); // Actualizar el contador con la longitud de los datos
      });
  };

  const obtenerAuditoriasEnProceso = () => {
    fetch(
      UrlApi +
        "/auditorias/enproceso/xsucursal/" +
        localStorage.getItem("suc_auth").split(",")
    )
      .then((data) => data.json())
      .then((data) => {
        setCountEnProceso(data.length); // Actualizar el contador con la longitud de los datos
      });
  };

  const obtenerAuditoriasFinalizado = () => {
    fetch(
      UrlApi +
        "/auditorias/finalizado/xsucursal/" +
        localStorage.getItem("suc_auth").split(",")
    )
      .then((data) => data.json())
      .then((data) => {
        setCountFinalizado(data.length); // Actualizar el contador con la longitud de los datos
      });
  };

  const obtenerAuditoriasAprobado = () => {
    fetch(
      UrlApi +
        "/auditorias/aprobado/xsucursal/" +
        localStorage.getItem("suc_auth").split(",")
    )
      .then((data) => data.json())
      .then((data) => {
        setCountAprobado(data.length); // Actualizar el contador con la longitud de los datos
      });
  };

  // ********************************************************

  const obtenerSectores = () => {
    fetch(UrlApi + "/sectores/sinrepetirmail/activos")
      .then((data) => data.json())
      .then((data) => {
        const localStorageSector = localStorage.getItem("sector");
        if (localStorageSector) {
          // Filtrar el sector que coincide con el ID de sector del localStorage "sector"
          const sectoresFiltrados = data.filter(
            (sector) => sector.id_sector !== parseInt(localStorageSector)
          );
          setSectores(sectoresFiltrados);
        } else {
          setSectores(data);
        }
      });
  };

  // ---------------------------------------------------------------

  useEffect(() => {
    if (tabla) {
      obtenerAuditorias();
    }
  }, [tabla, checkSwitchVerAprobados]);

  // CONTADORES
  useEffect(() => {
    obtenerAuditoriasRegistrado();
  }, [tabla]);

  useEffect(() => {
    obtenerAuditoriasEnProceso();
  }, [tabla]);

  useEffect(() => {
    obtenerAuditoriasFinalizado();
  }, [tabla]);

  useEffect(() => {
    obtenerAuditoriasAprobado();
  }, [tabla]);

  // ---------------------------------------------------------------

  // SECTORES PARA DELEGAR
  useEffect(() => {
    obtenerSectores();
  }, []);

  //*************************************************************************************************************************************/
  //  DIALOG PARA CARGA DE HALLAZGO
  const [openDialogAgregarHallazgo, setOpenDialogAgregarHallazgo] =
    React.useState(false);

  const handleCloseDialogCrearHallazgo = () => {
    setOpenDialogAgregarHallazgo(!openDialogAgregarHallazgo);
  };

  const handleOpenDialogCrearHallazgo = () => {
    setOpenDialogAgregarHallazgo(true);
    // GENERAR UUID PARA ARCHIVOS ADJUNTOS
    setUuid_hallazgo(uuidv4());
    setNewUuid(uuid_hallazgo);
  };

  //  DIALOG PARA ACEPTAR/RECHAZAR LA DELEGACION DE HALLAZGO
  const [openDialogARDelegacion, setOpenDialogARDelegacion] =
    React.useState(false);

  const handleOpenDialogARDelegacion = (row) => {
    setDatosAuditorias(row);
    setOpenDialogARDelegacion(true);
  };

  const handleCloseDialogARDelegacion = () => {
    setOpenDialogARDelegacion(!openDialogARDelegacion);
  };

  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

  const handleCloseCrearHallazgo = () => {
    setOpenDialogAgregarHallazgo(false);
    // RECARGAR TABLA
    obtenerAuditorias();
  };

  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

  //  DIALOG PARA CARGA DE HALLAZGO
  const [openDialogConfirmar, setOpenDialogConfirmar] = React.useState(false);

  const handleOpenDialogConfirmar = (row) => {
    setDatosAuditorias(row);
    setOpenDialogConfirmar(true);
  };

  const handleCloseDialogConfirmar = () => {
    setOpenDialogConfirmar(!openDialogConfirmar);
  };

  //*************************************************************************************************************************************/

  //  DIALOG PARA CARGA DE HALLAZGO
  const handleOpenDialogDelegar = (row) => {
    setDatosAuditorias(row);
    setOpenDialogDelegar(true);
  };

  const handleCloseDialogDelegar = () => {
    setOpenDialogDelegar(!openDialogDelegar);
  };

  //*************************************************************************************************************************************/

  const guardarConfirmar = async (e) => {
    logEventos(
      "Aprobar hallazgo",
      "Auditorias",
      "Se aprobó el hallazgo",
      localStorage.getItem("user")
    );

    console.log("Estoy por guardar");
    e.preventDefault();
    await fetch(UrlApi + "/auditorias/" + datosAuditorias.id_hallazgo, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        estado: 181,
      }),
    })
      .then((res) => {
        if (!res.err) {
          setOpenSnack(true);
          setColorMensaje("#D4EFDF");
          setMensaje("El hallazgo se guardó exitosamente !");
          console.log("Guardado");
          // ENVIAR MAIL
          datosAuditorias &&
            enviarmails(
              datosAuditorias.email_responsable,
              "Auditoria: Hallazgo Aprobado",
              `
              <div style="background-color: #f2f2f2; border-radius: 10px; padding: 20px; text-align: center;">

              <p>El hallazgo "${datosAuditorias.problema_sugerencia}" (ID: ${datosAuditorias.id_hallazgo}) fue comprobado y aprobado por el auditor.</p>
              </div>`
            );

          // RECARGAR CONTADORES DE ESTADO DE HALLAZGO
          // Verificación del rol de "Auditor" en el localStorage
          if (localStorage.getItem("auditor") === "1") {
            obtenerAuditoriasRegistrado();
            obtenerAuditoriasEnProceso();
            obtenerAuditoriasFinalizado();
            obtenerAuditoriasAprobado();
          }
        } else {
          setOpenSnack(false);
          setColorMensaje("#F1948A");
          setMensaje("Error al guardar el hallazgo");
          console.log("Error");
        }
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  //*************************************************************************************************************************************/

  const enviarCorreoAceptarDelegacion = async () => {
    try {
      // Envío de correo electrónico
      await new Promise((resolve, reject) => {
        // AL AUDITOR
        datosAuditorias &&
          enviarmails(
            datosAuditorias.email_auditor,
            "Auditoria: Delegación de Hallazgo Aceptada",
            `
            <div style="background-color: #f2f2f2; border-radius: 10px; padding: 20px; text-align: center;">
              <h3>La delegación del hallazgo "${datosAuditorias.problema_sugerencia}" (ID: ${datosAuditorias.id_hallazgo}) fue aceptada por el sector "${datosAuditorias.nombre_sector_delegado}".</h3>
            </div>
            `
          );

        // AL RESPONSABLE
        datosAuditorias &&
          enviarmails(
            datosAuditorias.email_responsable,
            "Auditoria: Delegación de Hallazgo Aceptada",
            `
            <div style="background-color: #f2f2f2; border-radius: 10px; padding: 20px; text-align: center;">
              <h3>La delegación del hallazgo "${datosAuditorias.problema_sugerencia}" (ID: ${datosAuditorias.id_hallazgo}) fue aceptada por el sector "${datosAuditorias.nombre_sector_delegado}".</h3>
            </div>
            `
          )
            .then(async () => {
              // Obtener la fecha actual
              const currentDate = new Date().toISOString().substring(0, 10);

              // Si el envío de correo es exitoso, guardar la acción relacionada con la aceptación de la delegación
              await fetch(UrlApi + "/auditorias_acciones", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  id_hallazgo: datosAuditorias.id_hallazgo,
                  accion_realizada: `El sector "${datosAuditorias.nombre_sector_delegado}" aceptó la delegación del hallazgo`,
                  fecha: currentDate, // Utilizar la fecha actual
                  uuid_accion: null,
                  estado: 183,
                  usuario_que_registra: localStorage.getItem("user"),
                }),
              });

              // PUT para actualizar el hallazgo
              await fetch(
                UrlApi + "/auditorias/" + datosAuditorias.id_hallazgo,
                {
                  method: "PUT",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({
                    estado_delegacion: 1,
                  }),
                }
              );

              resolve();
            })
            .catch((error) => {
              reject(error);
            });
      });
    } catch (error) {
      throw error;
    }
  };

  const enviarCorreoRechazarDelegacion = async () => {
    try {
      // Envío de correo electrónico
      await new Promise((resolve, reject) => {
        // AL AUDITOR
        datosAuditorias &&
          enviarmails(
            datosAuditorias.email_auditor,
            "Auditoria: Delegación de Hallazgo Rechazada",
            `
            <div style="background-color: #f2f2f2; border-radius: 10px; padding: 20px; text-align: center;">
              <h3>La delegación del hallazgo "${datosAuditorias.problema_sugerencia}" (ID: ${datosAuditorias.id_hallazgo}) fue rechazada por el sector "${datosAuditorias.nombre_sector_delegado}".</h3>
            </div>
            `
          );

        // AL RESPONSABLE
        datosAuditorias &&
          enviarmails(
            datosAuditorias.email_responsable,
            "Auditoria: Delegación de Hallazgo Rechazada",
            `
            <div style="background-color: #f2f2f2; border-radius: 10px; padding: 20px; text-align: center;">
              <h3>La delegación del hallazgo "${datosAuditorias.problema_sugerencia}" (ID: ${datosAuditorias.id_hallazgo}) fue rechazada por el sector "${datosAuditorias.nombre_sector_delegado}".</h3>
            </div>
            `
          )
            .then(async () => {
              // Obtener la fecha actual
              const currentDate = new Date().toISOString().substring(0, 10);

              // Si el envío de correo es exitoso, guardar la acción relacionada con el rechazo de la delegación
              await fetch(UrlApi + "/auditorias_acciones", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  id_hallazgo: datosAuditorias.id_hallazgo,
                  accion_realizada: `El sector "${datosAuditorias.nombre_sector_delegado}" rechazó la delegación del hallazgo`,
                  fecha: currentDate, // Utilizar la fecha actual
                  estado: 183,
                  usuario_que_registra: localStorage.getItem("user"),
                }),
              });

              // PUT para actualizar el hallazgo
              await fetch(
                UrlApi + "/auditorias/" + datosAuditorias.id_hallazgo,
                {
                  method: "PUT",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({
                    id_sector_delegado: null,
                    estado_delegacion: null,
                  }),
                }
              );

              resolve();
            })
            .catch((error) => {
              reject(error);
            });
      });
    } catch (error) {
      throw error;
    }
  };

  const aceptarDelegacion = async (e) => {
    logEventos(
      "Aceptar delegacion",
      "Auditorias",
      "Se aceptó delegar el hallazgo de auditoria",
      localStorage.getItem("user")
    );

    setIconoDeCarga(true);
    setDeshabilitarBotonRechazar(true);
    console.log("Estoy por guardar");
    e.preventDefault();
    try {
      // Envío de correo electrónico
      await enviarCorreoAceptarDelegacion();

      // Recargar tabla de acciones
      setRecargarAcciones(true);

      // Si el envío de correo es exitoso
      setIconoDeCarga(false);
      setOpenSnack(true);
      setColorMensaje("#D4EFDF");
      setMensaje("La delegación se aceptó exitosamente");
      setDeshabilitarBotonRechazar(false);
    } catch (error) {
      // Si hay un error en el envío de correo
      setIconoDeCarga(false);
      setOpenSnack(true);
      setColorMensaje("#F1948A");
      setMensaje("Error al enviar el correo");
      console.error("Error al enviar el correo:", error);
      setDeshabilitarBotonRechazar(false);
    }
  };

  const rechazarDelegacion = async (e) => {
    logEventos(
      "Rechazar delegacion",
      "Auditorias",
      "Se rechazó delegar el hallazgo de auditoria",
      localStorage.getItem("user")
    );

    setIconoDeCarga(true);
    setDeshabilitarBotonAceptar(true);
    console.log("Estoy por guardar");
    e.preventDefault();
    try {
      // Envío de correo electrónico
      await enviarCorreoRechazarDelegacion();
      // Si el envío de correo es exitoso
      setIconoDeCarga(false);
      setOpenSnack(true);
      setColorMensaje("#D4EFDF");
      setMensaje("La delegación se rechazó exitosamente");
      setDeshabilitarBotonAceptar(false);
    } catch (error) {
      // Si hay un error en el envío de correo
      setIconoDeCarga(false);
      setOpenSnack(true);
      setColorMensaje("#F1948A");
      setMensaje("Error al enviar el correo");
      console.error("Error al enviar el correo:", error);
      setDeshabilitarBotonAceptar(false);
    }
  };

  //*************************************************************************************************************************************/

  const guardarDelegar = async (e) => {
    logEventos(
      "Delegar hallazgo",
      "Auditorias",
      "Se delegó el hallazgo a otro sector",
      localStorage.getItem("user")
    );

    console.log("Estoy por guardar");
    e.preventDefault();
    setIconoDeCarga(true);

    // Obtener la fecha actual
    const currentDate = new Date().toISOString().substring(0, 10);
    try {
      await fetch(UrlApi + "/auditorias/" + datosAuditorias.id_hallazgo, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id_sector_delegado: sectorSeleccionado.id_sector,
          estado_delegacion: null,
        }),
      });

      const emails = sectorSeleccionado.emails.split(",");

      // Envía correos electrónicos a cada dirección asociada al sector seleccionado
      for (const email of emails) {
        await enviarmails(
          email.trim(),
          "Auditoria: Delegación de Hallazgo",
          `
        <div style="background-color: #f2f2f2; border-radius: 10px; padding: 20px; text-align: center;">
        <h3>Se solicitó delegar el hallazgo "${datosAuditorias.problema_sugerencia}" (ID: ${datosAuditorias.id_hallazgo}) al sector "${sectorSeleccionado.nombre_sector}".</h3>
        <p><strong>Auditor:</strong> "${datosAuditorias.auditor}" </p>
        <p><strong>Responsable:</strong> "${datosAuditorias.responsable}" </p>
        </div>
        <br/>
        `
        );
      }

      // GUARDAR ACCION
      // Mensaje para la acción realizada
      const mensajeAccion = `Se delegó el hallazgo al sector "${sectorSeleccionado.nombre_sector}"`;

      // Petición POST para crear una nueva acción
      await fetch(UrlApi + "/auditorias_acciones", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id_hallazgo: datosAuditorias.id_hallazgo,
          accion_realizada: mensajeAccion,
          fecha: currentDate,
          estado: 183,
          usuario_que_registra: localStorage.getItem("user"),
        }),
      });

      // Recargar tabla de acciones
      setRecargarAcciones(true);

      // Mostrar mensaje de éxito
      setOpenSnack(true);
      setColorMensaje("#D4EFDF");
      setMensaje("La solicitud de delegación fue enviada !");
      setIconoDeCarga(false);
    } catch (error) {
      setOpenSnack(false);
      setColorMensaje("#F1948A");
      setMensaje("Error al enviar la delegación");
      console.error("Error", error);
      setIconoDeCarga(false);
    }
  };

  //*************************************************************************************************************************************/

  const muiSearchTextFieldProps = {
    // para el buscar
    placeholder: "Buscar...",
    sx: { minWidth: "18rem", backgroundColor: "#ffffff" },
    variant: "outlined",
    color: "primary",
    size: "small",
  };

  const tableHeadCellProps = {
    align: "left", // Titulos de la tabla
    sx: {
      fontSize: 16,
      color: "white",
      fontWeight: "normal",
      backgroundColor: "#2471A3",
      borderColor: "black",
      "& .MuiSvgIcon-root": {
        color: "white", // color de los íconos
      },
    },
  };

  //*************************************************************************************************************************************/

  // ESTILO PARA LA TABLA
  const globalTheme = useTheme();
  const tableTheme = useMemo(
    () =>
      createTheme({
        palette: {
          mode: globalTheme.palette.mode,
          primary: globalTheme.palette.primary,
          info: {
            main: "rgb(255,122,0)",
          },
          background: {
            default: "rgb(234, 239, 241)",
          },
        },
        typography: {
          button: {
            textTransform: "none",
            fontSize: "1rem",
          },
        },
        components: {
          MuiTooltip: {
            styleOverrides: {
              tooltip: {
                fontSize: "0.8rem",
              },
            },
          },
        },
      }),
    [globalTheme]
  );

  const displayColumnDefOptions = {
    "mrt-row-actions": {
      muiTableHeadCellProps: {
        align: "center",
      },
      size: 95,
    },
  };

  const initialState = {
    density: "compact",
    showGlobalFilter: true,
    grouping: ["sucursal", "valor"],
    sorting: [
      {
        id: "sucursal",
        desc: true,
      },
      {
        id: "vencimiento",
        desc: true,
      },
    ],
    pagination: { pageIndex: 0, pageSize: 10 },
    columnVisibility: {
      uuid_hallazgo: false,
      email_auditor: false,
      email_responsable: false,
      id_sector_delegado: false,
      estado_delegacion: false,
    },
  };

  //*************************************************************************************************************************************/

  useEffect(() => {
    logEventos(
      "Carga de auditorias",
      "Auditorias",
      "Lista auditorias",
      localStorage.getItem("user")
    );
  }, []);

  //*************************************************************************************************************************************/

  return (
    <div>
      <Navbar />
      <Container maxWidth="xl" mt={1}>
        <Box mt={2} mb={4}>
          <ThemeProvider theme={tableTheme}>
            <MaterialReactTable
              data={auditorias}
              columns={columns}
              enableGrouping
              enableToolbarInternalActions={true} //las acciones al lado del search (agregar y full screen)
              displayColumnDefOptions={displayColumnDefOptions}
              layoutMode="grid"
              muiTableHeadCellProps={tableHeadCellProps}
              muiTableBodyCellProps={({ row }) => ({
                align: "left",
                sx: {
                  backgroundColor: "inherit", // Background del row
                  color: "text.primary",
                  borderColor: "transparent",
                },
              })}
              // Filas: Calcula color según estado + alternancia por index + baja/activo + hover
              muiTableBodyRowProps={({ table, row }) => {
                const rowIndex = table
                  .getRowModel()
                  .rows.findIndex((r) => r.id === row.id);
                const estado = row.original?.estado;
                const isInactiveRow = row.original?.baja === 1;

                // Paletas por estado. Cada una incluye dos tonos (para alternancia) + color hover + paleta para filas "inactivas"
                const palettes = {
                  179: {
                    // EN PROCESO (amarillo)
                    active: ["#fffbe0", "#fff4b2"],
                    hover: "#fff7a8",
                    inactive: ["#f9e5e5", "#f4d6d6"],
                  },
                  180: {
                    // FINALIZADO (verde)
                    active: ["#e7f9ea", "#d6f2d8"],
                    hover: "#d9f0d4",
                    inactive: ["#f3eaea", "#efe0e0"],
                  },
                  181: {
                    // APROBADO (azul claro)
                    active: ["#eaf9ff", "#d6f0ff"],
                    hover: "#cfeeff",
                    inactive: ["#f0f4f7", "#e8edf2"],
                  },
                  default: {
                    // REGISTRADO / por defecto (gris claro)
                    active: ["#f7f7f7", "#efefef"],
                    hover: "#e8e8e8",
                    inactive: ["#faf0f0", "#f3e8e8"],
                  },
                };

                const pal = palettes[estado] || palettes.default;
                const bgColor = isInactiveRow
                  ? pal.inactive[rowIndex % 2]
                  : pal.active[rowIndex % 2];

                return {
                  sx: {
                    backgroundColor: bgColor,
                    transition: "background-color 0.18s ease-in-out",
                    "& .MuiTableCell-root": {
                      borderBottom: "1px solid rgba(0,0,0,0.06)",
                    },
                  },
                };
              }}
              enableColumnActions={true}
              enableColumnFilters={false} //desactiva filtros x columna
              enableHiding={false}
              enableDensityToggle={false}
              enableFullScreenToggle={false}
              enableColumnDragging={false} //para arrastrar columnas
              enableEditing={false}
              localization={MRT_Localization_ES} //idioma
              initialState={initialState}
              muiSearchTextFieldProps={muiSearchTextFieldProps}
              enablePagination={true}
              enableStickyFooter
              positionActionsColumn="last" // posicion de la columna de acciones al final
              enableRowActions
              renderRowActions={({ row }) => (
                <>
                  {localStorage.getItem("auditor") === "1" ? (
                    // el usuario es AUDITOR y NO FORMA PARTE de ningún SECTOR:
                    // muestro botón de aprobación del hallazgo
                    <>
                      <Tooltip arrow placement="bottom" title="Ver adjunto">
                        <Button
                          style={{ padding: "6px", minWidth: "auto" }}
                          backgroundColor="#ffffff"
                          size="small"
                          onClick={() => {
                            setNewUuid(row.original.uuid_hallazgo);
                            setOpenCloseAdj(!openCloseAdj);
                          }}
                        >
                          <AttachFileIcon />
                        </Button>
                      </Tooltip>

                      {row.original.estado !== 181 && (
                        // SI ES AUDITOR Y TODAVIA NO SE APROBÓ EL HALLAZGO
                        <>
                          <Tooltip arrow placement="bottom" title="Delegar">
                            <Button
                              style={{ padding: "6px", minWidth: "auto" }}
                              backgroundColor="#ffffff"
                              size="small"
                              onClick={() =>
                                handleOpenDialogDelegar(row.original)
                              }
                            >
                              <CallMissedOutgoingIcon
                                style={{ color: "#b50ce8" }}
                              />
                            </Button>
                          </Tooltip>
                        </>
                      )}

                      {row.original.estado === 180 && (
                        // HALLAZGO - ESTADO: "FINALIZADO"
                        <>
                          {/* CONFIRMAR/APROBAR PENDIENTE */}
                          <Tooltip
                            arrow
                            placement="bottom"
                            title="Confirmar Hallazgo"
                          >
                            <Button
                              style={{ padding: "6px", minWidth: "auto" }}
                              size="small"
                              onClick={() =>
                                handleOpenDialogConfirmar(row.original)
                              }
                            >
                              <CheckCircleIcon color="success" />
                            </Button>
                          </Tooltip>
                        </>
                      )}
                    </>
                  ) : localStorage.getItem("auditor") !== "1" &&
                    localStorage.getItem("sector") === "null" ? (
                    // ES RESPONSABLE (NO AUDITOR NI SECTOR)
                    <>
                      <Tooltip arrow placement="bottom" title="Ver adjunto">
                        <Button
                          style={{ padding: "6px", minWidth: "auto" }}
                          backgroundColor="#ffffff"
                          size="small"
                          onClick={() => {
                            setNewUuid(row.original.uuid_hallazgo);
                            setOpenCloseAdj(!openCloseAdj);
                          }}
                        >
                          <AttachFileIcon />
                        </Button>
                      </Tooltip>

                      {/* Botón Delegar (Sectores) */}
                      {row.original.estado !== 181 && (
                        // TODAVIA NO SE APROBÓ EL HALLAZGO
                        <>
                          {/* BOTON PARA DELEGAR (ELEGIR SECTOR) */}
                          {row.original.id_sector_delegado === null && (
                            <>
                              {/* TODAVIA NO SE ACEPTÓ LA DELEGACIÓN (SOLO VA A APARECER DONDE NO HAYA SECTOR ASIGNADO)*/}
                              <Tooltip arrow placement="bottom" title="Delegar">
                                <Button
                                  style={{ padding: "6px", minWidth: "auto" }}
                                  backgroundColor="#ffffff"
                                  size="small"
                                  onClick={() =>
                                    handleOpenDialogDelegar(row.original)
                                  }
                                >
                                  <CallMissedOutgoingIcon
                                    style={{ color: "#b50ce8" }}
                                  />
                                </Button>
                              </Tooltip>
                            </>
                          )}
                        </>
                      )}
                    </>
                  ) : localStorage.getItem("auditor") !== "1" &&
                    localStorage.getItem("sector") !== "null" ? (
                    // VISTA DE USUARIO SECTOR
                    <>
                      <Tooltip arrow placement="bottom" title="Ver adjunto">
                        <Button
                          style={{ padding: "6px", minWidth: "auto" }}
                          backgroundColor="#ffffff"
                          size="small"
                          onClick={() => {
                            setNewUuid(row.original.uuid_hallazgo);
                            setOpenCloseAdj(!openCloseAdj);
                          }}
                        >
                          <AttachFileIcon />
                        </Button>
                      </Tooltip>

                      {/* Botón Delegación (Aceptar/Rechazar) */}
                      {parseInt(localStorage.getItem("sector")) ===
                        parseInt(row.original.id_sector_delegado) &&
                      row.original.estado_delegacion !== 1 &&
                      row.original.estado !== 181 ? (
                        // Mostrar el botón "Delegación"
                        <Tooltip arrow placement="bottom" title="Delegación">
                          <Button
                            style={{
                              color: "#b50ce8",
                              padding: "6px",
                              minWidth: "auto",
                            }}
                            backgroundColor="#ffffff"
                            size="small"
                            onClick={() =>
                              handleOpenDialogARDelegacion(row.original)
                            }
                          >
                            <AltRouteIcon />
                          </Button>
                        </Tooltip>
                      ) : row.original.estado !== 181 ? (
                        // Mostrar el botón "Delegar"
                        <Tooltip arrow placement="bottom" title="Delegar">
                          <Button
                            style={{ padding: "6px", minWidth: "auto" }}
                            backgroundColor="#ffffff"
                            size="small"
                            onClick={() =>
                              handleOpenDialogDelegar(row.original)
                            }
                          >
                            <CallMissedOutgoingIcon
                              style={{ color: "#b50ce8" }}
                            />
                          </Button>
                        </Tooltip>
                      ) : null}
                    </>
                  ) : (
                    (localStorage.getItem("auditor") !== "1" ||
                      localStorage.getItem("controlador") === "1") && (
                      // NO ES AUDITOR
                      <>
                        <Tooltip arrow placement="bottom" title="Ver adjunto">
                          <Button
                            style={{ padding: "6px", minWidth: "auto" }}
                            backgroundColor="#ffffff"
                            size="small"
                            onClick={() => {
                              setNewUuid(row.original.uuid_hallazgo);
                              setOpenCloseAdj(!openCloseAdj);
                            }}
                          >
                            <AttachFileIcon />
                          </Button>
                        </Tooltip>
                      </>
                    )
                  )}
                </>
              )}
              renderTopToolbarCustomActions={() => (
                <>
                  {localStorage.getItem("auditor") === "1" ? (
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "flex-start",
                        width: "100%",
                        py: 0.5,
                      }}
                    >
                      {/* Titulo y Contadores */}
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 0.5,
                          flex: 1,
                        }}
                      >
                        <Typography
                          sx={{
                            mb: 0.25,
                            lineHeight: 1.2,
                            fontSize: 20,
                          }}
                        >
                          Reporte Adm. de Incidentes
                        </Typography>

                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            flexWrap: "wrap",
                          }}
                        >
                          {/* Total */}
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              backgroundColor: "#1976d2",
                              color: "white",
                              px: 1.5,
                              py: 0.25,
                              borderRadius: 1,
                              minWidth: "auto",
                              height: 28,
                            }}
                          >
                            {" "}
                            <Typography
                              variant="caption"
                              sx={{ opacity: 0.9, fontSize: "0.75rem" }}
                            >
                              Total
                            </Typography>
                            <Typography
                              variant="subtitle1"
                              sx={{
                                fontWeight: "bold",
                                ml: 0.5,
                                fontSize: "0.9rem",
                              }}
                            >
                              {countTotal}
                            </Typography>
                          </Box>

                          {/* Contadores de estado */}
                          {/* REGISTRADO */}
                          <Box
                            sx={{
                              display: "flex",
                              gap: 0.75,
                              alignItems: "center",
                            }}
                          >
                            <Chip
                              label={`Registrado: ${countRegistrado}`}
                              size="small"
                              sx={{
                                backgroundColor: "#ffffffff",
                                color: "#6c757d",
                                height: 22,
                                "& .MuiChip-label": {
                                  px: 0.75,
                                  fontSize: "0.75rem",
                                },
                              }}
                            />
                            {/* EN PROCESO */}
                            <Chip
                              label={`En Proceso: ${countEnProceso}`}
                              size="small"
                              sx={{
                                backgroundColor: "#fff3e0",
                                color: "#dd6300ff",
                                height: 22,
                                "& .MuiChip-label": {
                                  px: 0.75,
                                  fontSize: "0.75rem",
                                },
                              }}
                            />
                            {/* FINALIZADO */}
                            <Chip
                              label={`Finalizado: ${countFinalizado}`}
                              size="small"
                              sx={{
                                backgroundColor: "#daffdaff",
                                color: "#2e7d32",
                                height: 22,
                                "& .MuiChip-label": {
                                  px: 0.75,
                                  fontSize: "0.75rem",
                                },
                              }}
                            />
                            {/* APROBADO */}
                            <Chip
                              label={
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 0.5,
                                  }}
                                >
                                  <Checkbox
                                    checked={checkSwitchVerAprobados}
                                    onChange={handleOnChangeSwitchVerAprobados}
                                    size="small"
                                    sx={{
                                      padding: 0,
                                      color: "#1565c0",
                                      "&.Mui-checked": {
                                        color: "#1565c0",
                                      },
                                      "& .MuiSvgIcon-root": {
                                        fontSize: 18,
                                      },
                                    }}
                                  />
                                  <span>{`Aprobado: ${countAprobado}`}</span>
                                </Box>
                              }
                              size="small"
                              sx={{
                                backgroundColor: "#e3f2fd",
                                color: "#1565c0",
                                height: 22,
                                "& .MuiChip-label": {
                                  px: 0.5,
                                  fontSize: "0.75rem",
                                  display: "flex",
                                  alignItems: "center",
                                },
                              }}
                            />
                          </Box>
                        </Box>
                      </Box>

                      {/* Acciones */}
                      {(localStorage.getItem("auditor") === "1" ||
                        localStorage.getItem("controlador") === "1") && (
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1.5,
                            mr: 2,
                          }}
                        >
                          <Button
                            variant="contained"
                            color="primary"
                            startIcon={<AddBoxTwoToneIcon />}
                            onClick={handleOpenDialogCrearHallazgo}
                            size="small"
                            sx={{
                              boxShadow: 2,
                              height: 32,
                            }}
                          >
                            Agregar Hallazgo
                          </Button>
                        </Box>
                      )}
                    </Box>
                  ) : (
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                        py: 0.5,
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: 20,
                        }}
                      >
                        Reporte Adm. de Incidentes
                      </Typography>

                      {(localStorage.getItem("auditor") === "1" ||
                        localStorage.getItem("controlador") === "1") && (
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1.5,
                            mr: 2,
                          }}
                        >
                          <Button
                            variant="contained"
                            color="primary"
                            startIcon={<AddBoxTwoToneIcon />}
                            onClick={handleOpenDialogCrearHallazgo}
                            size="small"
                            sx={{
                              boxShadow: 2,
                              height: 32,
                            }}
                          >
                            Agregar Hallazgo
                          </Button>
                        </Box>
                      )}
                    </Box>
                  )}
                </>
              )}
              renderDetailPanel={({ row }) => (
                <>
                  <Box sx={{ marginLeft: "40vh", minWidth: "400px" }}>
                    <Box
                      sx={{
                        width: "100%",
                        backgroundColor: "#fff",
                        borderRadius: "16px",
                      }}
                    >
                      <Box
                        sx={{
                          backgroundColor: "#2471A3",
                          color: "white",
                          borderRadius: "16px 16px 0 0",
                          display: "flex",
                          alignItems: "center",
                          p: 1,
                        }}
                      >
                        <AssignmentIcon sx={{ mr: 1 }} />
                        <Typography variant="subtitle1">
                          {row.original.descripcion_acciones}
                        </Typography>
                      </Box>

                      {recargarAcciones ? (
                        <Grid
                          item
                          marginTop={1}
                          display="flex"
                          justifyContent="center"
                        >
                          <CircularProgress />
                        </Grid>
                      ) : (
                        <>
                          <Auditorias_acciones
                            row={row}
                            auditorias={auditorias}
                            countTotal={countTotal}
                            obtenerAuditorias={obtenerAuditorias}
                            closeSnackPrincipal={handleCloseSnack}
                          />
                        </>
                      )}
                    </Box>
                  </Box>
                </>
              )}
            />
          </ThemeProvider>
        </Box>

        {openCloseAdj ? ( // ADJUNTAR
          <FileUploadHallazgo
            fileId={newUuid}
            openclose={true}
            mostrar={true}
            onClose={() => handleOpenCloseAdj(false)} // Proporciona una función de cierre
          />
        ) : null}

        {/* AGREGAR HALLAZGO */}
        <Dialog
          open={openDialogAgregarHallazgo}
          onClose={handleCloseDialogCrearHallazgo}
          maxWidth="lg"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: "16px",
              boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
              overflow: "hidden",
            },
          }}
        >
          <Auditorias_agregar_hallazgo
            openDialogAgregarHallazgo={openDialogAgregarHallazgo}
            disBtn={disBtn}
            // ADJUNTOS
            newUuid={newUuid}
            // CERRAR
            handleCloseCrearHallazgo={handleCloseCrearHallazgo}
          />
        </Dialog>

        {/* DIALOG PARA CONFIRMAR LA FINALIZACIÓN DE LA ACCIÓN */}
        <Dialog
          open={openDialogConfirmar}
          onClose={handleCloseDialogConfirmar}
          PaperProps={{
            sx: {
              borderRadius: "16px",
              border: "2px solid #2B76A6",
              boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
            },
          }}
        >
          <DialogContent sx={{ textAlign: "center", py: 3 }}>
            <DialogTitle textAlign={"center"}>
              {"¿Confirma que quiere finalizar este hallazgo?"}
            </DialogTitle>
            {datosAuditorias.problema_sugerencia}
          </DialogContent>

          <DialogActions sx={{ justifyContent: "center", pb: 2, gap: 18 }}>
            <Button
              variant="contained"
              color="error"
              onClick={handleCloseDialogConfirmar}
              sx={{
                borderRadius: "12px",
                textTransform: "none",
                fontWeight: 600,
              }}
            >
              Volver
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={guardarConfirmar}
              sx={{
                borderRadius: "12px",
                textTransform: "none",
                fontWeight: 600,
              }}
            >
              Confirmar
            </Button>
          </DialogActions>
        </Dialog>

        {/* DELEGAR A SUCURSAL */}
        <Dialog
          open={openDialogDelegar}
          onClose={handleCloseDialogDelegar}
          maxWidth="sm"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: "16px",
              boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
              overflow: "hidden",
            },
          }}
        >
          <Box>
            <Box
              sx={{
                backgroundColor: "#2B76A6",
                width: "100%",
                textAlign: "center",
              }}
            >
              <DialogTitle alignSelf="center" mr={3} mb={1}>
                <Typography
                  sx={{
                    color: "white",
                    fontWeight: "bold",
                  }}
                >
                  DELEGAR HALLAZGO
                </Typography>
              </DialogTitle>
            </Box>

            <DialogContent>
              <Container maxWidth="xl">
                <form onSubmit={guardarDelegar}>
                  <Grid container mb={1} spacing={1}>
                    <Grid item xs={12} mb={2}>
                      <Autocomplete
                        size="small"
                        required
                        disableClearable
                        noOptionsText={"Sectores No Disponibles"}
                        options={sectores}
                        autoHighlight
                        getOptionLabel={(sectores) =>
                          sectores.id_sector + "-" + sectores.nombre_sector
                        }
                        onChange={(event, value) =>
                          setSectorSeleccionado(value)
                        }
                        renderOption={(props, option) => (
                          <Box
                            component="li"
                            key={option.id}
                            sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                            {...props}
                          >
                            {option.id_sector} - {option.nombre_sector}
                          </Box>
                        )}
                        renderInput={(params) => (
                          <TextField
                            size="small"
                            placeholder="Tipee para buscar..."
                            {...params}
                            label="Sector"
                            inputProps={{
                              ...params.inputProps,
                            }}
                          />
                        )}
                      />
                    </Grid>
                  </Grid>

                  <Stack direction="row">
                    <Grid container direction={{ xs: "column", sm: "row" }}>
                      <Grid item xs={9}>
                        <Button
                          variant="contained"
                          color="error"
                          onClick={handleCloseDialogDelegar}
                          sx={{
                            borderRadius: "12px",
                            textTransform: "none",
                            fontWeight: 600,
                          }}
                        >
                          Volver
                        </Button>
                      </Grid>
                      {IconoDeCarga ? (
                        <Grid item marginLeft={4} marginTop={-1}>
                          <CircularProgress />
                        </Grid>
                      ) : (
                        <Grid item xs={3}>
                          <Button
                            fullWidth
                            variant="contained"
                            color="primary"
                            type="submit"
                            disabled={!sectorSeleccionado} // Deshabilitar el botón si no se ha seleccionado un sector
                            sx={{
                              borderRadius: "12px",
                              textTransform: "none",
                              fontWeight: 600,
                            }}
                          >
                            Delegar
                          </Button>
                        </Grid>
                      )}
                    </Grid>
                  </Stack>
                </form>
              </Container>
            </DialogContent>
          </Box>
        </Dialog>

        {/* DIALOG PARA CONFIRMAR/RECHAZAR LA DELEGACION */}
        <Dialog
          open={openDialogARDelegacion}
          onClose={handleCloseDialogARDelegacion}
          maxWidth="lg"
          fullWidth
        >
          <DialogTitle alignSelf="center" mr={3}>
            <b>{"Delegación de Hallazgo"}</b>
          </DialogTitle>

          <DialogContent>
            <div
              style={{
                textAlign: "center",
                fontFamily: "Arial, sans-serif",
                fontSize: "18px",
                lineHeight: "1.6",
              }}
            >
              <Container maxWidth="x1">
                El sector{" "}
                <span style={{ fontWeight: "bold" }}>
                  {datosAuditorias.nombre_sector_delegado}
                </span>{" "}
                tiene asignado el hallazgo{" "}
                <span style={{ fontWeight: "bold" }}>
                  {datosAuditorias.problema_sugerencia}
                </span>
              </Container>
            </div>
          </DialogContent>

          <DialogActions>
            <Grid container justifyContent="space-between">
              <Grid item>
                <Button
                  style={{ backgroundColor: "#d32f2f", color: "#ffffff" }}
                  variant="contained"
                  onClick={handleCloseDialogARDelegacion}
                >
                  Volver
                </Button>
              </Grid>
              <Grid item>
                <Grid container spacing={1}>
                  {IconoDeCarga ? (
                    <>
                      <Grid
                        item
                        marginRight={10}
                        marginLeft={10}
                        marginTop={-1}
                      >
                        <CircularProgress />
                      </Grid>

                      <Grid
                        item
                        marginRight={10}
                        marginLeft={10}
                        marginTop={-1}
                      >
                        <CircularProgress />
                      </Grid>
                    </>
                  ) : (
                    <>
                      <Grid item>
                        <Button
                          style={{
                            backgroundColor: "#d32f2f",
                            color: "#ffffff",
                          }}
                          variant="contained"
                          onClick={rechazarDelegacion}
                          disabled={deshabilitarBotonRechazar}
                        >
                          Rechazar Delegación
                        </Button>
                      </Grid>

                      <Grid item>
                        <Button
                          style={{
                            backgroundColor: "#2e7d32",
                            color: "#ffffff",
                          }}
                          variant="contained"
                          onClick={aceptarDelegacion}
                          disabled={deshabilitarBotonAceptar}
                        >
                          Confirmar Delegación
                        </Button>
                      </Grid>
                    </>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </DialogActions>
        </Dialog>

        <Stack spacing={2} sx={{ width: "100%" }}>
          <Snackbar
            open={openSnack}
            autoHideDuration={1500}
            onClose={handleCloseSnack}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
          >
            <Alert
              onClose={handleCloseSnack}
              severity="success"
              sx={{ width: "100%" }}
              style={{ backgroundColor: colormensaje, color: "black" }}
            >
              {mensaje}
            </Alert>
          </Snackbar>
        </Stack>
      </Container>
    </div>
  );
}

export default Auditorias;
